import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from "react";
import { TemplateLoadingScreen } from "@/components/templates/TemplateLoadingScreen";

type LazyModule = { default: ComponentType<Record<string, unknown>> };

/**
 * Wraps React.lazy in Suspense with the branded template loader.
 * Use for public routes so SEO/funnel pages don't bloat the initial bundle.
 */
export function lazyPage<T extends ComponentType<Record<string, unknown>>>(
  importFn: () => Promise<{ default: T } | LazyModule>,
): LazyExoticComponent<T> {
  const LazyComponent = lazy(importFn) as LazyExoticComponent<T>;

  const Wrapped = (props: Record<string, unknown>) => (
    <Suspense fallback={<TemplateLoadingScreen />}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return Wrapped as unknown as LazyExoticComponent<T>;
}
